import { Injectable, inject } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from "@angular/router";
import { UserApiService } from "@shared/services/users/userApi.service";
import { Observable, of } from "rxjs";
import { catchError, map } from "rxjs/operators";
@Injectable({
	providedIn: "root"
})
export class NewUserGuard implements CanActivate {
	private userService = inject(UserApiService);

	canActivate(
		next: ActivatedRouteSnapshot,
		state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> {
		// console.log('NEW USER GUARD');

		const email = next.queryParamMap.get("email"),
			tag = next.queryParamMap.get("tag"),
			dealerId = next.queryParamMap.get("dealerId");
		if (tag && email && dealerId) {
			return this.userService.verifyNewUserTagUsingGET(email, tag).pipe(
				map(() => true),
				catchError(() => of(false))
			);
		}
		return of(false);
	}
}